import React, {useEffect, useState} from "react";
import Slider from "rc-slider";
import {categoryApi} from "../../api";
import {Link} from "react-router-dom";

export default function FilterModal({ allProps }) {

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await categoryApi.getCategories(); // veya axios.get("/api/categories")
                setCategories(response.data.categories); // örnek response
            } catch (error) {
                console.error("Kategori verisi alınamadı:", error);
            }
        };

        fetchCategories();
    }, []);

    return (
        <div
            className="offcanvas offcanvas-start canvas-sidebar canvas-filter input-page"
            id="filterShop"
        >
            <div className="canvas-wrapper">
                <div className="canvas-header">
                    <span className="title">Filter</span>
                    <button
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="canvas-body">
                    <div className="widget-facet">
                        <div className="facet-title text-xl fw-medium" role="button">
                            <span>Categories</span>
                        </div>

                        <ul className="list-categories current-scrollbar">
                            {categories.map((cat) => (
                                <li key={cat.slug} className="cate-item">
                                    <div
                                        className="text-sm link cursor-pointer"
                                        onClick={() => allProps.setCategory(cat.slug)}
                                    >
                                        <span>{cat.name}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Availability */}
                    <div className="widget-facet">
                        <div
                            className="facet-title text-xl fw-medium"
                            data-bs-target="#availability"
                            role="button"
                            data-bs-toggle="collapse"
                            aria-expanded="true"
                            aria-controls="availability"
                        >
                            <span>Availability</span>
                            <span className="icon icon-arrow-up"/>
                        </div>
                        <div id="availability" className="collapse show">
                            <ul className="collapse-body filter-group-check current-scrollbar">
                                {/*<li*/}
                                {/*    className="list-item"*/}
                                {/*    onClick={() => allProps.setAvailability("In Stock")}*/}
                                {/*>*/}
                                {/*    <input*/}
                                {/*        type="radio"*/}
                                {/*        name="availability"*/}
                                {/*        className="tf-check"*/}
                                {/*        id="inStock"*/}
                                {/*        readOnly*/}
                                {/*        checked={allProps.availability === "In Stock"}*/}
                                {/*    />*/}
                                {/*    <label className="label">*/}
                                {/*        <span>In Stock</span>*/}
                                {/*    </label>*/}
                                {/*</li>*/}

                                {/*<li*/}
                                {/*    className="list-item"*/}
                                {/*    onClick={() => allProps.setAvailability("Unavailable")}*/}
                                {/*>*/}
                                {/*    <input*/}
                                {/*        type="radio"*/}
                                {/*        name="availability"*/}
                                {/*        className="tf-check"*/}
                                {/*        id="outStock"*/}
                                {/*        readOnly*/}
                                {/*        checked={allProps.availability === "Unavailable"}*/}
                                {/*    />*/}
                                {/*    <label className="label">*/}
                                {/*        <span>Out of Stock</span>*/}
                                {/*    </label>*/}
                                {/*</li>*/}
                                <li
                                    className="list-item"
                                    onClick={() => allProps.setAvailability("In Stock")}
                                >
                                    <input
                                        type="radio"
                                        name="availability"
                                        className="tf-check"
                                        id="inStock"
                                        readOnly
                                        checked={allProps.availability === "In Stock"}
                                    />
                                    <label className="label">
                                        <span>In Stock</span>
                                    </label>
                                </li>

                                <li
                                    className="list-item"
                                    onClick={() => allProps.setAvailability("Unavailable")}
                                >
                                    <input
                                        type="radio"
                                        name="availability"
                                        className="tf-check"
                                        id="outStock"
                                        readOnly
                                        checked={allProps.availability === "Unavailable"}
                                    />
                                    <label className="label">
                                        <span>Out of Stock</span>
                                    </label>
                                </li>


                            </ul>
                        </div>
                    </div>

                    {/* Price */}
                    <div className="widget-facet">
                        <div
                            className="facet-title text-xl fw-medium"
                            data-bs-target="#price"
                            role="button"
                            data-bs-toggle="collapse"
                            aria-expanded="true"
                            aria-controls="price"
                        >
                            <span>Price</span>
                            <span className="icon icon-arrow-up"/>
                        </div>
                        <div id="price" className="collapse show">
                            <div className="collapse-body widget-price filter-price">
                                <div className="price-val-range">
                                    <Slider
                                        value={allProps.price}
                                        onChange={(price) => allProps.setPrice(price)}
                                        range
                                        min={0}
                                        max={2000}
                                    />
                                </div>
                                <div className="box-value-price">
                                    <span className="text-sm">Price:</span>
                                    <div className="price-box">
                                        <div className="price-val">${allProps.price[0]}</div>
                                        <span>-</span>
                                        <div className="price-val">${allProps.price[1]}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="widget-facet">
                        <div
                            className="facet-title text-xl fw-medium"
                            data-bs-target="#size"
                            role="button"
                            data-bs-toggle="collapse"
                            aria-expanded="true"
                            aria-controls="size"
                        >
                            <span>Size</span>
                            <span className="icon icon-arrow-up"/>
                        </div>
                        <div id="size" className="collapse show">
                            <div className="collapse-body filter-size-box flat-check-list">

                                {["XS", "S", "M", "L", "XL", "XXL"].map((sizeOption) => (
                                    <div
                                        key={sizeOption}
                                        onClick={() => allProps.toggleSize(sizeOption)}
                                        className={`check-item size-item size-check ${allProps.size.includes(sizeOption) ? "active" : ""}`}
                                    >
                                        <span className="size">{sizeOption}</span>
                                    </div>
                                ))}


                            </div>
                        </div>
                    </div>


                    {/* Gender Filter */}
                    <div className="widget-facet">
                        <div
                            className="facet-title text-xl fw-medium"
                            data-bs-target="#gender"
                            role="button"
                            data-bs-toggle="collapse"
                            aria-expanded="true"
                            aria-controls="gender"
                        >
                            <span>Gender</span>
                            <span className="icon icon-arrow-up"/>
                        </div>
                        <div id="gender" className="collapse show">
                            <ul className="collapse-body filter-group-check current-scrollbar">
                                {["male", "female", "unisex"].map((genderOption) => (
                                    <li
                                        key={genderOption}
                                        className="list-item"
                                        onClick={() => allProps.toggleGender(genderOption)}
                                    >
                                        <input
                                            type="checkbox"
                                            className="tf-check"
                                            readOnly
                                            checked={allProps.gender.includes(genderOption)}
                                        />
                                        <label className="label">
                                            <span>{genderOption}</span>
                                        </label>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
}
